import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import {
  clearDiscountCodeAuthorizers,
  getDiscountCodeAuthorizers,
} from '../../../../actions/sales/DiscountCodeAuthorizer';

export const DiscountCodeAuthorizerSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearDiscountCodeAuthorizers,
  dispatchGetDiscountCodeAuthorizers,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearDiscountCodeAuthorizers(), []);

  const onInputChangeUser = (inputValue) => {
    if (inputValue.trim().length && inputValue.trim().length >= 4) {
      const index = inputValue.indexOf(',');

      let query = [`customer.firstName:${inputValue}`, 'active:true'];

      if (index >= 0) {
        const { length } = inputValue;
        const firstName = inputValue.substring(0, index).trim();
        const lastName = inputValue.substring(index + 1, length).trim();
        query = ['active:true'];
        if (firstName.length) query.push(`customer.firstName:${firstName}`);
        if (lastName.length) query.push(`customer.lastName:${lastName}`);
      }

      dispatchGetDiscountCodeAuthorizers({ query });
    }
  };

  const filterOption = (users) => users;

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangeUser}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      filterOption={filterOption}
      {...rest}
    />
  );
};

DiscountCodeAuthorizerSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetDiscountCodeAuthorizers: PropTypes.func.isRequired,
  dispatchClearDiscountCodeAuthorizers: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
};

DiscountCodeAuthorizerSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca así: nombre,apellido',
};

const mapStateToProps = ({ SalesUnit }) => ({
  options: SalesUnit.DiscountCodeAuthorizer.getIn([
    'all',
    'content',
    'content',
  ]).map((authorizer) => ({
    value: authorizer.id,
    label: authorizer.customer.fullName,
  })),
  loading: SalesUnit.DiscountCodeAuthorizer.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetDiscountCodeAuthorizers: getDiscountCodeAuthorizers,
  dispatchClearDiscountCodeAuthorizers: clearDiscountCodeAuthorizers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountCodeAuthorizerSelect);
